import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { img } from "../../constants/assets";
import PartnerCounters from "../../components/PartnerCounters";
import PartnerModal from "../../components/PartnerModal";
import { useBookDemo } from "../../context/BookDemoContext";
import GlobalConnected, {
  FeatureIcon,
} from "../../components/GlobalConnected";
import BlurRevealText from "../../components/BlurRevealText";
import ReliabilitySection from "../../components/ReliabilitySection";
import EmpowerBusinesses from "../../components/EmpowerBusinesses";

const howItWorksIcons = [
  "create-icon-user.svg",
  "customisze-icon.svg",
  "customize2.svg",
  "launch-icon.svg",
];
const businessIcons = ["cart.svg", "white-label.svg", "flexibleplan.svg", "scalable.svg"];
const whyFeatureIcons = [
  "heigh-commissions.svg",
  "globalcover.svg",
  "easy-integration.svg",
  "dedicatesupport.svg",
];

const aiCardIcons = ["airecive.svg", "routing.svg", "fraud.svg", "demand.svg"];
const ctaFeatureIcons = ["globe", "tower", "shield", "code"];
function CtaRocketIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.03-2.91l-2.91-2.91c-.78-.73-2.07-.74-2.91-.03z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinejoin="round"
      />
      <path
        d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinejoin="round"
      />
      <path
        d="M9 12H4s.55-3.03 2-5c1.62-2.2 5-3 5-3M15 12h5s-.55-3.03-2-5c-1.62-2.2-5-3-5-3"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function CtaHeadsetIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M3 11v4a2 2 0 0 0 2 2h1v-8H5a2 2 0 0 0-2 2zM19 11v4a2 2 0 0 1-2 2h-1v-8h1a2 2 0 0 1 2 2z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinejoin="round"
      />
      <path
        d="M7 15v2a5 5 0 0 0 10 0v-2"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <path
        d="M12 3a5 5 0 0 0-5 5v3h10V8a5 5 0 0 0-5-5z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinejoin="round"
      />
    </svg>
  );
}
function Partners() {
  const { t } = useTranslation();
  const [isPartnerModalOpen, setIsPartnerModalOpen] = useState(false);
  const { openBookDemo } = useBookDemo();
  const businessSolutions = t("partners.businessSolutions", { returnObjects: true });
  const whyFeatures = t("partners.whyFeatures", { returnObjects: true });
  const ctaTitleSegments = [
    { text: t("ctaBanner.titleBefore") },
    {
      text: t("ctaBanner.titleHighlight"),
      className: "cta-banner-accent",
      breakAfter: true,
    },
    { text: t("ctaBanner.titleAfter") },
  ];
  const ctaFeatures = t("ctaBanner.features", { returnObjects: true });
  return (
    <>
      <section
        className="industries-hero partners-hero"
        style={{ "--hero-bg-image": `url(${img("partnerbg.svg")})` }}
      >
        <div className="container py-2">
          <div className="row align-items-center g-4 g-lg-5">
            <div className="col-md-6 d-flex hero-content">
              <div className="animate__animated animate__fadeInLeftBig animate__slow">
                <p className="banner-sub-heading p-2">
                  {t("partners.heroOverline")}
                </p>
                <h1 className="solutions-hero-title">
                  {t("partners.heroTitle1")}
                  <br />
                  <span className="gradient-text-span">
                    {t("partners.heroTitleHighlight")}
                  </span>
                </h1>
                <p className="pera-cs solutions-hero-desc">
                  {t("partners.heroDesc")}
                </p>
                <div className="btn-group gap-3">
                  <button
                    className="btn-cs btn-booking py-3 fw-normal"
                    type="button"
                    onClick={() => setIsPartnerModalOpen(true)}
                  >
                    {t("partners.becomePartner")}{" "}
                    <span className="img-fluid">
                      <img src={img("arrow.svg")} alt="" />
                    </span>
                  </button>
                  <button
                    className="btn-cs btn-lang d-flex gap-2 py-3 fw-normal"
                    type="button"
                  >
                    {t("common.exploreDemo")}
                    <span className="img-fluid">
                      <img src={img("Border.svg")} alt="" />
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <PartnerCounters />

      <section className="platform-section py-50 partner-platform">
        <div className="container">
          <div className="row align-items-center g-4 g-lg-5">
            <div className="col-lg-6 hero-content h-auto">
              <h2 className="inner-heading mb-0">{t("partners.solutionsTitle")}</h2>
              <div className="row g-3 why-choose-cards mt-2">
                {businessSolutions.map((item, index) => (
                  <div className="col-12" key={item.title}>
                    <article className="why-choose-card d-flex gap-3 align-items-start">
                      <span className="auto-mate-sale" aria-hidden="true">
                        <img src={img(businessIcons[index])} alt="" />
                      </span>
                      <div>
                        <h3 className="why-choose-card-title mb-2">{item.title}</h3>
                        <p className="why-choose-card-text">{item.description}</p>
                      </div>
                    </article>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-lg-6">
              <div className="platform-media">
                <img
                  className="platform-image w-100"
                  src={img("business.svg")}
                  alt={t("partners.businessImageAlt")}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="succed-sec py-50">
        <div className="container">
          <div className="row align-items-center g-4 g-lg-5">
            <div className="col-lg-6 hero-content h-auto">
              <p className="banner-sub-heading p-2">
                {t("partners.whyPartnersOverline")}
              </p>
              <h2 className="inner-heading mb-0">{t("partners.whyPartnersTitle")}</h2>
              <p className="pera-cs">{t("partners.whyPartnersDesc")}</p>
              <div className="row g-3 why-choose-cards mt-2 partner-connection">
                {whyFeatures.map((item, index) => (
                  <div className="col-md-6" key={item.title}>
                    <article className="why-choose-card  bg-transparent box-shadow-none">
                      <span className="platform-check" aria-hidden="true">
                        <img src={img(whyFeatureIcons[index])} alt="" />
                      </span>
                      <div>
                        <h3 className="why-choose-card-title">{item.title}</h3>
                        <p className="why-choose-card-text">{item.description}</p>
                      </div>
                    </article>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-lg-6">
              <div className="platform-media">
                <img
                  className="platform-image w-100"
                  src={img("powerai.svg")}
                  alt={t("partners.powerAiImageAlt")}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <ReliabilitySection />

      <EmpowerBusinesses />

      <section className="cta-banner-section industry-partners">
        <div className="container">
          <div className="cta-banner">
            <div className="row align-items-center g-4">
              <div className="col-lg-7">
                <p className="cta-banner-label">
                  {t("ctaBanner.label")}
                </p>
                <BlurRevealText
                  as="h2"
                  className="cta-banner-title"
                  segments={ctaTitleSegments}
                />
                <p className="cta-banner-text">
                  <Trans
                    i18nKey="ctaBanner.subtitle"
                    components={{ 1: <span className="cta-banner-accent" /> }}
                  />
                </p>
                <div className="cta-banner-features">
                  {ctaFeatures.map((item, index) => (
                    <div className="cta-banner-feature" key={item.label}>
                      <FeatureIcon type={ctaFeatureIcons[index]} />
                      <div>
                        <strong className="cta-banner-stat">{item.stat}</strong>
                        <span className="cta-banner-feature-label">
                          {item.label}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="col-lg-5">
                <div className="cta-banner-actions">
                  <button
                    className="cta-btn-primary"
                    type="button"
                    onClick={() => setIsPartnerModalOpen(true)}
                  >
                    <span className="cta-btn-icon">
                      <CtaRocketIcon />
                    </span>
                    <span className="cta-btn-label">{t("common.startNow")}</span>
                    <span className="cta-btn-icon">
                      <img src={img("arrow.svg")} alt="" />
                    </span>
                  </button>
                  <button
                    className="cta-btn-secondary"
                    type="button"
                    onClick={openBookDemo}
                  >
                    <span className="cta-btn-icon">
                      <CtaHeadsetIcon />
                    </span>
                    <span className="cta-btn-label">{t("common.talkToSales")}</span>
                    <span className="cta-btn-icon">
                      <img src={img("arrow.svg")} alt="" />
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <PartnerModal
        isOpen={isPartnerModalOpen}
        onClose={() => setIsPartnerModalOpen(false)}
      />
    </>
  );
}

export default Partners;
